import React from "react";
import { Box } from "@mui/material";
import { WEB_MAIN_COLOR } from "../common/sharedFunctions";
import { useSelector } from "react-redux";

function CircularLoading() {
  const settings = useSelector((state) => state.settingsdata.settings);
  const MAIN_COLOR = WEB_MAIN_COLOR(settings?.appCat) || "#E5A93C";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
        bgcolor: "transparent",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          border: `3.5px solid rgba(229, 169, 60, 0.18)`,
          borderTopColor: MAIN_COLOR,
          borderRightColor: MAIN_COLOR,
          transform: "translate3d(0, 0, 0)",
          willChange: "transform",
          contain: "strict",
          animation: "d2gSpin 1s linear infinite",
          "@keyframes d2gSpin": {
            "0%": {
              transform: "rotate(0deg) translate3d(0, 0, 0)",
            },
            "100%": {
              transform: "rotate(360deg) translate3d(0, 0, 0)",
            },
          },
        }}
      />
    </Box>
  );
}

export default CircularLoading;

